import { OriginalCard } from '../../store/interfacesResponse';

export class OriginalCardHelper {
  static getImageUris(oc: OriginalCard) {
    return oc.card_faces?.[0]?.image_uris || oc.image_uris;
  }
}
